var Vendd = (function (Vendd) {
    'use strict';

    Vendd.ProductList = (function (ProductList) {

        ProductList.Messages = (function (Messages) {

            Messages.GetModel = function (list, serviceConfiguration, type, uri, includeFilters, defaultUriFilter) {
                var data = {
                    list: list,
                    serviceConfiguration: serviceConfiguration,
                    type: type,
                    uri: uri,
                    includeFilters: includeFilters || false,
                    defaultUriFilter: defaultUriFilter || ""
                }
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.ProductList.Messages.GetModel', data);
            };
            Messages.GetModel.className = 'Vendd.ProductList.Messages.GetModel';

            Messages.GetModelSuccess = function (response, list) {
                response.position = "Reload";
                response.list = list;
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.ProductList.Messages.GetModelSuccess', response);
            };
            Messages.GetModelSuccess.className = 'Vendd.ProductList.Messages.GetModelSuccess';

            Messages.GetModelFailed = function (response, list) {
                response.list = list;
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.ProductList.Messages.GetModelFailed', response);
            };
            Messages.GetModelFailed.className = 'Vendd.ProductList.Messages.GetModelFailed';

            Messages.GetLanguageTranslateUrl = function (url) {
                var data = {
                    url: url
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.ProductList.Messages.GetLanguageTranslateUrl', data);
            };
            Messages.GetLanguageTranslateUrl.className = 'Vendd.ProductList.Messages.GetLanguageTranslateUrl';

            Messages.GetLanguageTranslateUrlSuccess = function (response) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.ProductList.Messages.GetLanguageTranslateUrlSuccess', response);
            };
            Messages.GetLanguageTranslateUrlSuccess.className = 'Vendd.ProductList.Messages.GetLanguageTranslateUrlSuccess';

            Messages.GetLanguageTranslateUrlFailed = function (response) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.ProductList.Messages.GetLanguageTranslateUrlFailed', response);
            };
            Messages.GetLanguageTranslateUrlFailed.className = 'Vendd.ProductList.Messages.GetLanguageTranslateUrlFailed';

            return Messages;

        })(ProductList.Messages || {});

        return ProductList;

    })(Vendd.ProductList || {});

    return Vendd;

})(Vendd || {});